const INTERNAL_AUTH_PROVIDER_PREFIX = '__';
export { INTERNAL_AUTH_PROVIDER_PREFIX };
